
<div class="research-container">
  <div class="container">
    <div class="section-box">
      <div data-aos="fade-up" data-aos-duration="1000">
        <h3 class="section-title">
          &nbsp;Research&nbsp;<i class="fab fa-searchengin"></i>
        </h3>
      </div>
    </div>
    <div class="media">
      <i class="fab fa-connectdevelop"></i>&nbsp;&nbsp;
      <div class="media-body">
        <h5 class="mt-0">Lecturer & Researcher</h5>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iusto ratione odit placeat eligendi in, assumenda unde?

        <div class="media mt-3">
            <i class="far fa-eye"></i>&nbsp;&nbsp;
          <div class="media-body">
            <h5 class="mt-0">Scientific Publications & Conferences</h5>
            Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at.
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>